var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPengar = function SvgPengar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61 3.2v.943q.568.09.929.375.36.284.688.87l-.938.525q-.423-.77-1.106-.77-.424 0-.703.25a.8.8 0 0 0-.278.625.77.77 0 0 0 .226.568q.22.22.894.524.582.264.962.498.38.232.572.45.544.586.544 1.418 0 .818-.49 1.443a2.37 2.37 0 0 1-1.3.837v.996H7.77v-.967q-.942-.155-1.438-.65-.495-.495-.731-1.529l1.058-.221q.215.73.53 1.044.325.298.87.298.528 0 .885-.342.35-.336.35-.87 0-.477-.293-.765a2.7 2.7 0 0 0-.44-.315 8 8 0 0 0-.743-.382q-.933-.42-1.226-.77a1.82 1.82 0 0 1-.467-1.255q0-.346.11-.645.112-.298.32-.54.21-.244.518-.421a2.8 2.8 0 0 1 .697-.28V3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8m0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6"
  }))));
};
export default SvgPengar;